import { warningToast } from "@idwal/idwal-react-components";
import { TFunction } from "i18next";

export const downloadFile = async (url: string, downloadName: string, t: TFunction) => {
    const response = await fetch(url);

    if (!response.ok) {
        warningToast(t("report.downloadFailed"));
        return;
    }

    const blob = await response.blob();
    const link = document.createElement('a');
    link.href = URL.createObjectURL(blob);
    link.download = downloadName;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link); // Clean up the link element
}
